import { Container } from "../Container";
import { Div } from "../../Div";
import { List } from "./List";
import { toMap } from "../../../../../HA";

export class Carousel extends Container {
    protected createSelf() {
        super.createSelf();
        this.addClass("carousel");
        const list = new List(toMap({
            classes: ["feedl", "fc"],
            d: this.get("d"),
            m: this.get("m"),
            trans: this.get("trans"),
        }));
        this.addToData("list", list);
        this.appendChild(list);

        if (this.get("show")) {
            this.appendChild(new Div(toMap({
                classes: ["car-action", "car-action-l"],
                t: "div",
                txt: "<<",
            })));
            this.appendChild(new Div(toMap({
                classes: ["car-action", "car-action-r"],
                t: "div",
                txt: ">>",
            })));
        }
    }
}
